// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3qhTH","ranges":"BmiRanges_ranges__3_HBZ"};